import axios from 'axios';
import { toast } from '../components/v2/Toast';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';

/**
 * Extract a human-readable message from an axios error.
 * FastAPI may return `detail` as a string, or (on 422) an array of
 * {loc, msg, ...} objects — this normalizes all shapes to a single string.
 */
export const getErrorMessage = (error, fallback = 'Что-то пошло не так') => {
  if (!error?.response) return 'Нет соединения с сервером';
  const detail = error.response.data?.detail;
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail)) {
    return detail.map((d) => d?.msg || (typeof d === 'string' ? d : '')).filter(Boolean).join('; ') || fallback;
  }
  if (detail && typeof detail === 'object') return detail.msg || fallback;
  return fallback;
};

const axiosInstance = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Attach JWT token to every request
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('access_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Handle 401 responses — clear token and redirect to login
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('access_token');
      localStorage.removeItem('user');
      // Redirect to home if not already there
      if (window.location.pathname !== '/' && window.location.pathname !== '/login') {
        window.location.href = '/';
      }
    }
    if (error.code === 'ECONNABORTED') {
      toast.error('Превышено время ожидания. Попробуйте ещё раз.');
    } else if (!error.response) {
      toast.error('Нет соединения с сервером.');
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
